import { render } from "./FattureScadute.vue?vue&type=template&id=5f8b3556&scoped=true"
import script from "./FattureScadute.vue?vue&type=script&lang=js"
export * from "./FattureScadute.vue?vue&type=script&lang=js"

import "./FattureScadute.vue?vue&type=style&index=0&id=5f8b3556&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8b3556"]])

export default __exports__